export const addEditPetValidation = {
  name: [{ required: true, message: 'Name is required!' }],
  breed: [{ required: true, message: 'Breed is required!' }],
  color: [{ required: true, message: 'Color is required!' }],
  chipNumber: [{ required: true, message: 'Chip number is required!' }],
};
